
import { Link } from "react-router-dom";

const subTitle = "Services ";
const title = "What We Do";


const featureList = [
    {
        imgUrl: 'assets/images/feature/admission.jpg',
        imgAlt: 'feature rajibraj91 rajibraj',
        title: 'Admission Process',
        titleSpan: ' We streamline your university admission process for a hassle-free experience.',
        btnText: 'View More',
    },
    {
        imgUrl: 'assets/images/feature/interview.jpg',
        imgAlt: 'feature rajibraj91 rajibraj',
        title: 'Interview preparation',
        titleSpan: 'Expert guidance to help you ace your university interviews with confidence.',
        btnText: 'View More',
    },
    {
        imgUrl: 'assets/images/feature/entrance.jpg',
        imgAlt: 'feature rajibraj91 rajibraj',
        title: ' University entrance test',
        titleSpan: ' Get tailored support to prepare and succeed in your entrance exams.',
        btnText: 'View More',
    },
    {
        imgUrl: 'assets/images/feature/assessment.jpg',
        imgAlt: 'feature rajibraj91 rajibraj',
        title: 'Course assessment',
        titleSpan: 'We assist in evaluating and selecting the best course for your career goals.',
        btnText: 'View More',
    },
    {
        imgUrl: 'assets/images/feature/customer.jpg',
        imgAlt: 'feature rajibraj91 rajibraj',
        title: 'Free Customer services',
        titleSpan: ' Enjoy 24/7 support for all your study abroad queries and concerns.',
        btnText: 'View More',
    },
    {
        imgUrl: 'assets/images/feature/counsling.jpg',
        imgAlt: 'feature rajibraj91 rajibraj',
        title: ' Free Education Counselling',
        titleSpan: 'Personalized counselling to help you choose the right academic path.',
        btnText: 'View More',
    },
    {
        imgUrl: 'assets/images/feature/visa.jpg',
        imgAlt: 'feature rajibraj91 rajibraj',
        title: '  Visa Assistance',
        titleSpan: ' Comprehensive guidance for smooth and successful visa application processing.',
        btnText: 'View More',
    },
    {
        imgUrl: 'assets/images/feature/departure.jpg',
        imgAlt: 'feature rajibraj91 rajibraj',
        title: '  Pre-Post Departure Assistance',
        titleSpan: 'From pre-departure briefings to post-arrival support, we’re with you.',
        btnText: 'View More',
    },
    {
        imgUrl: 'assets/images/feature/accumodation.jpg',
        imgAlt: 'feature rajibraj91 rajibraj',
        title: '  Accommodation Assistance',
        titleSpan: ' Helping you find safe and comfortable housing abroad.',
        btnText: 'View More',
    },
    {
        imgUrl: 'assets/images/feature/scholarship.jpg',
        imgAlt: 'feature rajibraj91 rajibraj',
        title: '  Scholarships',
        titleSpan: ' We guide you in securing scholarships to reduce your education costs.',
        btnText: 'View More',
    },
]


const Feature = () => {
    return (
        <div className="feature-section padding-tb">
            <div className="container">
                <div className="section-header text-center">
                    <span className="subtitle">{subTitle}</span>
                    <h2 className="title">{title}</h2>
                </div>
                <div className="section-wrapper">
                    <div className="row g-4  row-cols-sm-3 justify-content-center">
                        {featureList.map((val, i) => (
                            <div className="" key={i}>
                                {/* <div className="feature-item">
                                    <div className="feature-inner">
                                        <div className="feature-thumb">
                                            <img width={50} src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                                        </div>
                                        <div className="feature-content">
                                            <h6 className="">{val.title} <span>{val.titleSpan}</span></h6>
                                            <Link to="/course-single" className="lab-btn-text">{val.btnText} <span></span></Link>
                                        </div>
                                    </div>
                                </div> */}


                                <div class="max-w-sm bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
                                    <a href="#">
                                        <img class="rounded-t-lg" src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                                    </a>
                                    <div class="p-5">
                                        <a href="#">
                                            <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">{val.title}</h5>
                                        </a>
                                        <p class="mb-3 font-normal text-gray-700 dark:text-gray-400">{val.titleSpan}</p>
                                        {/* <a href="#" class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                            Read more
                                            <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                                            </svg>
                                        </a> */}
                                    </div>
                                </div>

                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Feature;